import styled, { css } from "styled-components";

export const linkCss = css`
  color: #08a0a0;
`;

export const Link = styled.span`
  display: contents;

  a {
    ${linkCss}
  }
`;
